import script from "./SortByDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./SortByDropdown.vue?vue&type=script&setup=true&lang=js"

import "./SortByDropdown.vue?vue&type=style&index=0&id=30aaba02&lang=scss"

export default script